import { SqlRbacAction } from "services/rbac/action";
import { PrivilegeObjectType } from "services/rbac/types";

import { ANY_OBJECT_NAME } from "components/App/accessManager";

export const usersPrivileges = (accountName: string) => [
  {
    objectType: PrivilegeObjectType.account,
    objectName: accountName,
    privilegeType: SqlRbacAction.USER_CREATE,
  },
  {
    objectType: PrivilegeObjectType.account,
    objectName: accountName,
    privilegeType: SqlRbacAction.USER_MODIFY_ANY,
  },
  {
    objectType: PrivilegeObjectType.user,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY,
  },
];

export const rolesPrivileges = (accountName: string) => [
  {
    objectType: PrivilegeObjectType.account,
    objectName: accountName,
    privilegeType: SqlRbacAction.ROLE_CREATE,
  },
  {
    objectType: PrivilegeObjectType.account,
    objectName: accountName,
    privilegeType: SqlRbacAction.ROLE_MODIFY_ANY,
  },
  {
    objectType: PrivilegeObjectType.account,
    objectName: accountName,
    privilegeType: SqlRbacAction.GRANTS_MANAGE,
  },
  {
    objectType: PrivilegeObjectType.role,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY,
  },
];

export const ownershipPrivileges = (accountName: string) => [
  {
    objectType: PrivilegeObjectType.account,
    objectName: accountName,
    privilegeType: SqlRbacAction.ROLE_MODIFY_ANY,
  },
  {
    objectType: PrivilegeObjectType.account,
    objectName: accountName,
    privilegeType: SqlRbacAction.USER_MODIFY_ANY,
  },
  {
    objectType: PrivilegeObjectType.account,
    objectName: accountName,
    privilegeType: SqlRbacAction.DATABASE_MODIFY_ANY,
  },
  {
    objectType: PrivilegeObjectType.account,
    objectName: accountName,
    privilegeType: SqlRbacAction.ENGINE_MODIFY_ANY,
  },
  {
    objectType: PrivilegeObjectType.user,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY,
  },
  {
    objectType: PrivilegeObjectType.role,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY,
  },
  {
    objectType: PrivilegeObjectType.database,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY,
  },
  {
    objectType: PrivilegeObjectType.engine,
    objectName: ANY_OBJECT_NAME,
    privilegeType: SqlRbacAction.MODIFY,
  },
];
